import { pageKey } from "../order-list/const";

// for pagination
export default {
  data() {
    return {
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      }
    };
  },
  methods: {
    sizeChange(size) {
      this.pagination.pageSize = size;
      window.localStorage.setItem(pageKey, size);
      this.search();
    },
    currentChange(val) {
      this.pagination.currentPage = val;
      this.search();
    }
  }
};
